export type SfxKey = 'jump' | 'blight' | 'skeleton' | 'coin' | 'heart' | 'death';

// Глобальный мастер‑уровень для SFX (0.0..1.0)
export const MASTER_VOLUME = 1.0;

// Громкость фоновой музыки (0.0..1.0)
export const MUSIC_VOLUME = 0.5;

// Индивидуальные уровни громкости SFX (0.0..1.0)
export const SFX_VOLUME: Record<SfxKey, number> = {
  jump: 0.3,
  blight: 0.6,
  skeleton: 0.4,
  coin: 0.7,
  heart: 0.6,
  death: 0.8,
};

// Разрешённые URL аудио ассетов (одна точка входа для путей)
export const AUDIO_URLS = {
  bgm: new URL('../assets/audio/game-music-loop.opus', import.meta.url).toString(),
  sfx: {
    jump: new URL('../assets/audio/powerful-air-whooshes.opus', import.meta.url).toString(),
    blight: new URL('../assets/audio/blood-splash.opus', import.meta.url).toString(),
    skeleton: new URL('../assets/audio/enemy-death-voice.opus', import.meta.url).toString(),
    coin: new URL('../assets/audio/arcade-score-interface.opus', import.meta.url).toString(),
    heart: new URL('../assets/audio/small-hit-in-a-game.opus', import.meta.url).toString(),
    death: new URL('../assets/audio/wrong-answer-fail.opus', import.meta.url).toString(),
  } as Record<SfxKey, string>,
};
